import { render, staticRenderFns } from "./LayoutRegister.vue?vue&type=template&id=4de2e5be&scoped=true"
import script from "./LayoutRegister.vue?vue&type=script&lang=js"
export * from "./LayoutRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de2e5be",
  null
  
)

export default component.exports